import { __awaiter, __generator } from "tslib";
import fitty from 'fitty';
import { createElement } from '@gn-audio/core/common/templating';
import { emulateClickWhenEnterOrSpacePressed } from '../../../../utilities';
import { defaultPreviewTextValue } from '../../constants';
import { getEngravingPreviewImageUrl } from '../../utilities';
import { BasketEngravingInputComponent } from '../basket-engraving-input';
import './basket-engraving-popup.component.scss';
import preview3dRenderingTemplate from '../../templates/engraving-preview-3d-rendering.html';
import previewImageTemplate from '../../templates/engraving-preview-image.html';
import componentTemplate from './basket-engraving-popup.component.html';
var BasketEngravingPopupComponent = /** @class */ (function () {
    function BasketEngravingPopupComponent() {
        var _this = this;
        this.appendEngravingPreview = function (popup) {
            var data = {
                productName: _this.item.product_name,
            };
            var previewTemplate = _this.engraving3dRenderingUuid ? preview3dRenderingTemplate : previewImageTemplate;
            var previewElement = createElement(previewTemplate, data);
            popup.querySelector('.basket-engraving-popup__preview-rendering').appendChild(previewElement);
        };
        this.handleKeysPressesOnCloseIcon = function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.closeIcon);
        };
        this.disableSaveEngravingButton = function () {
            _this.saveEngravingButton.setAttribute('disabled', 'disabled');
        };
        this.onEngravingMessageChange = function (message, isValid) {
            var engravingMessage = isValid && !!message ? message : defaultPreviewTextValue;
            _this.isEngravingMessageValid = isValid;
            if (_this.engraving3dRenderingUuid) {
                _this.sendMessageToIframe(_this.engraving3dRenderingUuid, engravingMessage);
            }
            else {
                _this.previewText.textContent = engravingMessage;
            }
            if (!isValid || !message) {
                _this.disableSaveEngravingButton();
            }
            else {
                _this.saveEngravingButton.removeAttribute('disabled');
            }
        };
        this.removeEngravingMessage = function () {
            _this.sendEngravingMessage('');
        };
        this.saveEngravingMessage = function () {
            if (!_this.isEngravingMessageValid) {
                _this.disableSaveEngravingButton();
                return;
            }
            _this.sendEngravingMessage(_this.input.value.trim());
        };
        this.destroy = this.destroy.bind(this);
    }
    BasketEngravingPopupComponent.prototype.render = function (_a) {
        var callback = _a.callback, data = _a.data, eventBus = _a.eventBus, translations = _a.translations, engraving3dRenderingUuid = _a.engraving3dRenderingUuid;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.initializeProperties(callback, data, engraving3dRenderingUuid);
                        this.createTemplate(data, translations);
                        this.setupEvents();
                        return [4 /*yield*/, this.handleEngravingPreview()];
                    case 1:
                        _b.sent();
                        this.setupEngravingInput(data, eventBus, translations);
                        this.setupSaveAndRemoveButtons();
                        this.setupScrollLock();
                        this.adjustTextSizeAndFocus();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketEngravingPopupComponent.prototype.initializeProperties = function (callback, data, engraving3dRenderingUuid) {
        this.callback = callback;
        this.item = Object.assign({}, data);
        if (!this.item.item_id) {
            this.item.item_id = '';
        }
        this.engraving3dRenderingUuid = engraving3dRenderingUuid;
    };
    BasketEngravingPopupComponent.prototype.createTemplate = function (data, translations) {
        this.element = createElement(componentTemplate, data, translations);
        this.appendEngravingPreview(this.element);
        document.body.insertAdjacentElement('beforeend', this.element);
        this.overlay = this.element.querySelector('.basket-engraving-popup__overlay');
        this.closeIcon = this.element.querySelector('.basket-engraving-popup__close');
    };
    BasketEngravingPopupComponent.prototype.setupEvents = function () {
        var _this = this;
        this.element.addEventListener('keydown', function (event) {
            if (event.key !== "Escape" /* KeyboardCode.Esc */) {
                return;
            }
            _this.destroy();
        });
        this.overlay.addEventListener('click', this.destroy);
        this.closeIcon.addEventListener('click', this.destroy);
        this.closeIcon.addEventListener('keydown', this.handleKeysPressesOnCloseIcon);
    };
    BasketEngravingPopupComponent.prototype.handleEngravingPreview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var iframe_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.engraving3dRenderingUuid) return [3 /*break*/, 2];
                        iframe_1 = this.element.querySelector("iframe");
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                iframe_1.addEventListener("load", resolve);
                                iframe_1.addEventListener("error", reject);
                            })];
                    case 1:
                        _b.sent();
                        this.sendMessageToIframe(this.engraving3dRenderingUuid, this.getEngravingValue() || defaultPreviewTextValue);
                        return [3 /*break*/, 4];
                    case 2:
                        this.previewText = this.element.querySelector('.basket-engraving-popup__preview-text-value');
                        this.previewText.textContent = this.getEngravingValue() || defaultPreviewTextValue;
                        this.image = this.element.querySelector('.basket-engraving-popup__preview-image');
                        _a = this.image;
                        return [4 /*yield*/, getEngravingPreviewImageUrl(this.item.product_id)];
                    case 3:
                        _a.src = _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BasketEngravingPopupComponent.prototype.getEngravingValue = function () {
        var _a;
        return (_a = this.item) === null || _a === void 0 ? void 0 : _a.c_engravingMsg;
    };
    BasketEngravingPopupComponent.prototype.setupEngravingInput = function (data, eventBus, translations) {
        this.input = new BasketEngravingInputComponent();
        this.input.render({
            container: this.element.querySelector('.basket-engraving-popup__user-inputs'),
            data: data,
            eventBus: eventBus,
            onChange: this.onEngravingMessageChange,
            translations: translations,
        });
    };
    BasketEngravingPopupComponent.prototype.setupSaveAndRemoveButtons = function () {
        this.saveEngravingButton = this.element.querySelector('.basket-engraving-popup__action.save');
        this.saveEngravingButton.addEventListener('click', this.saveEngravingMessage);
        this.removeEngravingButton = this.element.querySelector('.basket-engraving-popup__action.remove');
        this.removeEngravingButton.addEventListener('click', this.removeEngravingMessage);
    };
    BasketEngravingPopupComponent.prototype.setupScrollLock = function () {
        document.body.classList.add('no-scroll');
    };
    BasketEngravingPopupComponent.prototype.adjustTextSizeAndFocus = function () {
        this.fittyInstance = fitty(this.element.querySelector('.basket-engraving-popup__preview-text-value'), {
            minSize: 6,
            maxSize: 36,
            multiLine: false,
        });
        this.onEngravingMessageChange(this.getEngravingValue(), true);
        this.input.focus();
    };
    BasketEngravingPopupComponent.prototype.destroy = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        document.body.classList.remove('no-scroll');
        (_a = this.fittyInstance) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.input) === null || _b === void 0 ? void 0 : _b.destroy();
        (_c = this.saveEngravingButton) === null || _c === void 0 ? void 0 : _c.removeEventListener('click', this.saveEngravingMessage);
        (_d = this.removeEngravingButton) === null || _d === void 0 ? void 0 : _d.removeEventListener('click', this.removeEngravingMessage);
        (_e = this.closeIcon) === null || _e === void 0 ? void 0 : _e.removeEventListener('click', this.destroy);
        (_f = this.closeIcon) === null || _f === void 0 ? void 0 : _f.removeEventListener('keydown', this.handleKeysPressesOnCloseIcon);
        (_g = this.overlay) === null || _g === void 0 ? void 0 : _g.removeEventListener('click', this.destroy);
        (_h = this.element) === null || _h === void 0 ? void 0 : _h.remove();
    };
    BasketEngravingPopupComponent.prototype.sendMessageToIframe = function (engraving3dRenderingUuid, message) {
        var iframe = this.element.querySelector("iframe");
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage({
                uuid: engraving3dRenderingUuid,
                engraving: message,
            }, "*");
        }
    };
    BasketEngravingPopupComponent.prototype.sendEngravingMessage = function (message) {
        if (this.callback) {
            this.callback(message);
        }
        this.destroy();
    };
    return BasketEngravingPopupComponent;
}());
export { BasketEngravingPopupComponent };
